'use client';

import React from 'react';
import classes from './warning.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/lib/store';
import { setErrorMessage, setErrorRedirectUrl } from '@/slice/error';
import { useRouter } from 'next/navigation';

const WarningAlert = ({ buttonName }: { buttonName: string }) => {
  const router = useRouter();

  const dispatch = useDispatch();
  const errorMessage = useSelector((state: RootState) => state.error.message);
  const redirectUrl = useSelector(
    (state: RootState) => state.error.redirectUrl,
  );
  const isError = useSelector((state: RootState) => state.error.isError);

  const handleConfirm = (e: any) => {
    e.stopPropagation();
    dispatch(setErrorMessage(''));
    dispatch(setErrorRedirectUrl(''));
    if (redirectUrl !== '') {
      router.replace(`${process.env.NEXT_PUBLIC_API_URL}/${redirectUrl}`);
    }
  };

  return (
    <article
      className={classes.msgLayer}
      style={errorMessage !== '' ? { display: 'block' } : { display: 'none' }}
    >
      <div className={classes.msgLayerWrapper}>
        <div className={classes.msgContents}>
          <div className={classes.msgGroupBox}>
            <div className={classes.msgViewBox}>
              <div className={classes.icBox}>
                <i
                  className={`${classes.ic} ${isError ? classes.icInfo : classes.icCheck}`}
                ></i>
              </div>
              <div
                className={classes.msgBox}
                dangerouslySetInnerHTML={{
                  __html: errorMessage.replaceAll('\n', '<br/>'),
                }}
              />
              {/*{errorMessage.split('\n').map((line: string, idx: number) => (*/}
              {/*  <div key={idx}>{line}</div>*/}
              {/*))}*/}
            </div>
            <div className={classes.msgBtnBox}>
              <div className={classes.btnList}>
                <div className={classes.btnBox}>
                  <button
                    className={`${classes.btn} ${classes.themeSuccess}`}
                    onClick={handleConfirm}
                  >
                    <span>{buttonName}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>
  );
};

export default WarningAlert;
